/**
 * @generated SignedSource<<7a66a7fd08d4cfc9cdd86d93d69c2af2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useMentionUsersQuery$variables = {};
export type useMentionUsersQuery$data = {
  readonly viewer: {
    readonly peopleSuggestions: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null;
      readonly email: string | null;
    }>;
  } | null;
};
export type useMentionUsersQuery = {
  variables: useMentionUsersQuery$variables;
  response: useMentionUsersQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "PersonSuggestion",
  "kind": "LinkedField",
  "name": "peopleSuggestions",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useMentionUsersQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useMentionUsersQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8db8864c06059f3cac0aa88847c57f37",
    "id": null,
    "metadata": {},
    "name": "useMentionUsersQuery",
    "operationKind": "query",
    "text": "query useMentionUsersQuery {\n  viewer {\n    peopleSuggestions {\n      id\n      name\n      email\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7bb1827c213726e0c7c2924dd55c5d6d";

export default node;
